import {FetchBaseQueryError} from '@reduxjs/toolkit/query';

import {FORCE_2FA, NO_ACCOUNT_URL, TRIAL_UPGRADE_URL} from 'app/urls';

import {doesErrorMatch, extractActionRequestError} from '../sweet-api/matchers';

import type {AppDispatchType} from '../AppStore';
import type {AnyAction, Middleware} from '@reduxjs/toolkit';

// this middleware identify global errors (that are not related with the API being accessed)
// and heandle them
export const APIGlobalErrorHandlerMiddleware: Middleware =
  () => (next: AppDispatchType) => (action: AnyAction) => {
    let error: FetchBaseQueryError | undefined = undefined;

    if ((error = extractActionRequestError(action))) {
      // redirect trial-expired users to /procedures/trial-expired/
      if (
        // rtk-query errors out while parsing the TRIAL_EXPIRED text content so it's a PARSING_ERROR type
        error.status === 'PARSING_ERROR' &&
        error.data === 'TRIAL_EXPIRED' &&
        error.originalStatus === 400
      ) {
        window.location.replace(TRIAL_UPGRADE_URL);
        return;
      }

      // redirect users with no account to /accounts/empty/
      if (doesErrorMatch(error, 403, 'USER_HAS_NO_ACCOUNT')) {
        window.location.replace(NO_ACCOUNT_URL);
        return;
      }

      if (doesErrorMatch(error, 400, 'FORCE_2FA')) {
        window.location.replace(FORCE_2FA);
        return;
      }
    }

    return next(action);
  };
